import { Customer } from '@/features/auth/domain/customer'
import { User } from '@/features/auth/domain/user'
import { FullStoryAnalyticsService } from '@/utils/analytics/FullStoryAnalyticsService'

export class AnalyticsService {
  private orgId: string
  private fs: FullStoryAnalyticsService

  constructor(orgId: string) {
    this.orgId = orgId
    this.fs = new FullStoryAnalyticsService({ orgId, shouldRun: this.shouldRun })
  }

  initAnalytics(customer: Customer, user: User, loggedInAsCustomer: boolean, tokenRequestedFrom: string | undefined) {
    if (!this.shouldRun()) {
      return
    }
    this.fs.startCapturing()
    this.fs.init(customer, user, loggedInAsCustomer, tokenRequestedFrom)
  }

  resetAnalytics() {
    if (!this.shouldRun()) {
      return
    }
    this.fs.reset()
  }

  sendEvent(name: string, data: Record<string, unknown> = {}) {
    this.fs.sendEvent(name, data)
  }

  update(updates: Record<string, unknown>) {
    this.fs.update(updates)
  }

  private shouldRun() {
    return this.orgId != undefined && this.orgId !== 'undefined' && this.orgId !== '' && this.orgId.trim() !== ''
  }
}
